module.exports = __webpack_public_path__ + "static/media/GenericBanner@1x.1f1b0c0e.png";